import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useProgress } from "@react-three/drei";
import { LargeScreen, tab } from "../../../deviceStyle";
import { ExploreLottie, InfinityLottie } from "./lottie";
import "./app.css";
export const MobileLoadingScreen = ({ setStartExperience, startExperience }) => {
  const { progress } = useProgress();
  const [rollUp, setRollUp] = useState(false);

  const Explore = () => {
    setRollUp(true);
    setTimeout(() => {
      setStartExperience(true);
    }, [1000]);
  };
  const handleButtonClick = () => {
    if (progress === 100) {
      Explore();
    }
  };

  return (
    <Container startExperience={rollUp}>
      
      <div className="App">
      <iframe
        src="https://sarathi-landing-page.web.app" // Replace 'https://example.com' with the URL you want to display in the iframe
        title="Background"
        frameBorder="0"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      ></iframe>
        <Button onClick={handleButtonClick}>Explore Now</Button>
    </div>
      
      
        
    
    </Container>
  );
};

// Styled components and other code here...

const Button = styled.button`
  position: absolute; /* Position the button relative to its containing element */
  top: 75%; /* Adjusted for better responsiveness */
  left: 20%; /* Center the button horizontally */
  transform: translate(-50%, -50%); /* Center the button both horizontally and vertically */
  padding: 60px 30px;
  background-color: #007bff;
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  opacity: 0;
  :hover {
    background-color: #0056b3;
  }
`;

const Container = styled.div`
  z-index: 100;
  height: 100vh;
  width: 100vw;
  background-color: black;
  color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column; /* Added for proper layout */
  align-items: center;
  justify-content: center;
  transform: ${(props) =>
    props.startExperience ? "translateY(-100%)" : "translateY(0)"};
  transition: 1s ease all;
  overflow: hidden;
  font-family: "HK Grotesk", sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0 20px;
  ${tab({
    padding: "0 100px"
  })}
`;
const Body = styled.div`
  width: fit-content;
  z-index: 10;
  max-height: fit-content;
`;

const Head = styled.div`
  margin-bottom: 40px;
`;

const Heading = styled.h2`
  font-size: 45px;
  text-transform: uppercase;
  margin: 0;
  padding: 0;
  font-weight: 900;
  display: inline-flex;
  ${tab({
    fontSize: "60px"
  })}
  ${LargeScreen({
    fontSize: "70px"
  })}
`;
const Paragraph = styled.p`
  font-size: 20px;
  font-weight: 600;
  text-align: right;
  ${LargeScreen({
    fontSize: "30px",
    marginTop: "100px",
    width: "50%",
    marginLeft: "auto"
  })}
  ${tab({
    fontSize: "35px",
    width: "60%",
    marginLeft: "auto"
  })}
`;

// Other styled components...

export default MobileLoadingScreen;
